/**
 * Configure Store script file
 *
 * @package    App
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createHistory from 'history/createBrowserHistory';
import Immutable from 'seamless-immutable';

import rootReducer from './reducers';
import { INITIAL_STATE as TRANSLATION_INITIAL_STATE, TRANSLATIONS } from './reducers/translationReducer';
import { axiosMiddleware, localStorageMiddleware } from 'Middleware';

export const history = createHistory();

const startup = () => {
    let initialState = {};

    try {
        let auth = JSON.parse(localStorage.auth);
        if (auth) {
            initialState.auth = Immutable({
                isLoggedIn: true,
                AccessToken: auth.token,
                user: auth.user,
                accessTokenType: auth.type,
            });
        }
    } catch (error) {} // eslint-disable-line

    initialState.translation = TRANSLATION_INITIAL_STATE;
    let locale = localStorage.locale;
    if (locale && TRANSLATIONS[locale]) {
        initialState.translation = initialState.translation.merge({
            locale,
            messages: TRANSLATIONS[locale],
        });
    }

    return initialState;
};

export default function configureStore() {
    let preloadedState = startup();

    let store = createStore(
        rootReducer,
        preloadedState,
        composeWithDevTools(applyMiddleware(
            thunk,
            routerMiddleware(history),
            axiosMiddleware([]),
            localStorageMiddleware(),
        )),
    );

    return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js